var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationValidUptoIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37067 4.70001L4.37059 0.700012M11.1999 0.700012L11.1999 4.70001M18.0292 4.70001L18.0291 0.700012M24.3706 0.700012L24.3707 4.70001M27.7 9.20001V5.70001C27.7 4.04316 26.3568 2.70001 24.7 2.70001H3.69995C2.0431 2.70001 0.699951 4.04316 0.699951 5.70001V9.20001M27.7 9.20001V24.7C27.7 26.3569 26.3568 27.7 24.7 27.7H3.69995C2.0431 27.7 0.699951 26.3569 0.699951 24.7V9.20001M27.7 9.20001H0.699951",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationValidUptoIcon1);
export default __webpack_public_path__ + "static/media/registrationValidUptoIcon1.4a60ef88c2a272f6f728d996de5dab27.svg";
export { ForwardRef as ReactComponent };